import { formatDate } from "utils/calendarDateFormatting";

export const generateImagePDF = async (images: string[], fileName?: string) => {
  // AIDEV-NOTE: jsPDF (340 kB, 10,6 % vstupního chunku) se stahuje až tady. Funkce je
  // volaná výhradně z click handlerů, takže se za to platí ~200 ms po kliknutí — obě
  // volající komponenty proto po dobu běhu blokují tlačítko a ukazují spinner.
  const { default: JsPDF } = await import("jspdf");

  // AIDEV-NOTE: `onerror` tu musí být. Bez něj se promise u nedostupného obrázku nikdy
  // neusadí, `Promise.all` visí věčně a `finally` u volajícího nedoběhne — tlačítko by
  // zůstalo natrvalo zablokované. Dřív to bylo neškodné (kliknutí prostě nic neudělalo).
  const imagePromises = images.map(
    async url =>
      await new Promise<HTMLImageElement>((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve(img);
        };
        img.onerror = () => {
          reject(new Error(`Nepodařilo se načíst obrázek pro PDF: ${url}`));
        };
        img.src = url;
      }),
  );

  const loadedImages = await Promise.all(imagePromises);

  const pdf = new JsPDF({
    unit: "mm",
    format: "a4",
    orientation: "portrait",
  });

  const offset = 10;

  for (const [index, img] of Array.from(loadedImages.entries())) {
    try {
      const props = pdf.getImageProperties(img);

      const ratio = props.width / props.height;
      const imageWidth = pdf.internal.pageSize.getWidth() - 2 * offset;
      const imageHeight = imageWidth / ratio;

      pdf.addImage(img, "PNG", offset, offset, imageWidth, imageHeight);

      if (index < loadedImages.length - 1) {
        pdf.addPage();
      }
    } catch (error) {
      console.error(error);
    }
  }

  pdf.save(fileName ?? `to-natrenujes_${formatDate(new Date())}`);
};
